module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-7.6eb5649a.jpg";